// db.js
import Dexie from 'dexie';

export const indexedDB = new Dexie('recTV');
indexedDB.version(1).stores({
  videos: 'key, base64, updatedAt', // Primary key and indexed props
});